import React, { useEffect } from 'react'
import Box from "@mui/material/Box";
import { useDispatch, useSelector } from "react-redux";
import BreadCrumb from "app/components/BreadCrumb";
import { ScrollableView } from "app/components/ScrollableView";
import { useTranslation } from "react-i18next";
import { useInjectReducer, useInjectSaga } from "redux-injectors";
import { actions, reducer, sliceKey } from "./redux/slice";
import { AdminPrice as adminPriceSaga } from "./redux/saga";
import { useStyles } from "./styles";
import AdminPriceTable from "./components/AdminPriceTable"
import { AddButton } from 'app/components/Button/AddButton';
import AddPriceModal from './components/AddPriceModal'

import {
  selectAdminPriceData,
  selectAdminPriceLoad,
  selectAdminPriceMeta,
} from "./redux/selector";


const AdminPrice = () => {
const styles = useStyles();
const { t, i18n } = useTranslation();

const dispatch = useDispatch();
const rows = useSelector(selectAdminPriceData)
const loading = useSelector(selectAdminPriceLoad)
const meta = useSelector(selectAdminPriceMeta)

useInjectReducer({
  key: sliceKey,
  reducer,
});

useInjectSaga({
  key: sliceKey,
  saga: adminPriceSaga
})

useEffect(() => {
  dispatch(actions.getPriceList());
}, [dispatch]);

  const hasMoreItems = meta.currentPage < meta.totalPages;

  const getNextPage = () => {
    if (!loading && hasMoreItems) {
      dispatch(actions.getNextPageItems());
    }
  };

  return (
    <Box className={styles.container}>
        <Box className={styles.scrollContent} dir={i18n.dir()}>
          <Box className={styles.pageContent}>
            <BreadCrumb title={t("SIDEBAR.INVENTORY")} iconPosition="end" />
            <Box>
              <AddButton onClick={() => dispatch(actions.openAddModal())} label={t("ADMIN_PRICE.ADD")} />
            </Box>
            <Box className={styles.tableContainer}>
              <ScrollableView
                borderless
                height="calc(100vh - 200px)"
                loadMore={getNextPage}
                hasMoreItems={hasMoreItems}
              >
                <AdminPriceTable rows={rows} loading={loading && rows.length === 0} />
              </ScrollableView>
            </Box>
          </Box>
        </Box>
        <AddPriceModal />
    </Box>
  )
}

export default AdminPrice
